import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useAuth from '../auth/useAuth';
import { LogOut, Loader2 } from 'lucide-react';

const LogoutButton = () => {
  const { logoutUser } = useAuth();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const handleLogout = () => {
    setLoading(true);
    setTimeout(() => {
      logoutUser();
      navigate('/login');
    }, 1500);
  };

  return (
    <button
      onClick={handleLogout}
      disabled={loading}
      /* className={`flex gap-2.5 ml-7 text-red-500 hover:underline cursor-pointer items-center ${
        loading ? 'opacity-50 cursor-not-allowed' : ''
      }`} */
    >
      {/* {loading ? <Loader2 className="animate-spin w-4 h-4" /> : <LogOut />} */}
      {loading ? 'Logging out...' : 'Logout'}
    </button>
  );
};

export default LogoutButton;
